import { addStyles } from 'ethcss'
import { colors, grid, IStyles, item } from '../../../theme'
import { defaultThemeStyles } from 'blocks.app/sidebar/Sidebar-theme'

const reportTasksStyles: IStyles = {
    menuItem: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.center,
        ...grid.p_mini,
        ...item.pointer,
        position: 'relative',
        textAlign: 'center',
        ...item.transitionErase,
        cursor: 'pointer',
        textDecoration: 'none',
        color: `var(--var-module-sidebar-component-sidebar-style-menuText, ${defaultThemeStyles.menuText})`,
        '&:hover': {
            color: `var(--var-module-sidebar-component-sidebar-style-menuTextHover, ${defaultThemeStyles.menuTextHover})`,
        },
    },
    iconWrapper: {
        ...grid.full,
        ...grid.col,
        backgroundColor: `var(--var-module-sidebar-component-filePreview-style-background, ${defaultThemeStyles['file-background']})`,
    },
    modalWrapper: {
        padding: 20,
    },
    confirmModal: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 2000,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    confirmModalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        borderRadius: 20,
        padding: 20,
        textAlign: 'center',
    },
    confirmModalDescription: {
        marginTop: 10,
        color: colors.grey,
    },
    buttons: {
        ...grid.row,
        justifyContent: 'center',
        marginTop: 20,
    },
    button: {
        margin: '0 10px',
    },
}

addStyles(reportTasksStyles)
export default reportTasksStyles
